var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.944,
    height: 12.829,
    viewBox: "0 0 13.944 12.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.193,17.991v4.462H5.616V17.991h5.578m0-1.116H5.616A1.116,1.116,0,0,0,4.5,17.991v4.462a1.116,1.116,0,0,0,1.116,1.116h5.578a1.116,1.116,0,0,0,1.116-1.116V17.991A1.116,1.116,0,0,0,11.193,16.875Z",
    transform: "translate(0 -6.239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.568,5.616V8.4H17.991V5.616h5.578m0-1.116H17.991a1.116,1.116,0,0,0-1.116,1.116V8.4A1.116,1.116,0,0,0,17.991,9.52h5.578A1.116,1.116,0,0,0,24.684,8.4V5.616A1.116,1.116,0,0,0,23.568,4.5Z",
    transform: "translate(-6.239 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,17.991v2.789H23.616V17.991H26.4m0-1.116H23.616A1.116,1.116,0,0,0,22.5,17.991v2.789a1.116,1.116,0,0,0,1.116,1.116H26.4a1.116,1.116,0,0,0,1.116-1.116V17.991A1.116,1.116,0,0,0,26.4,16.875Z",
    transform: "translate(-9.076 -6.239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,5.616V8.4H5.616V5.616H8.4M8.4,4.5H5.616A1.116,1.116,0,0,0,4.5,5.616V8.4A1.116,1.116,0,0,0,5.616,9.52H8.4A1.116,1.116,0,0,0,9.52,8.4V5.616A1.116,1.116,0,0,0,8.4,4.5Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.cd5e942425d15253dbacc7e81168447d.svg";
export { ForwardRef as ReactComponent };